import { Flex } from "@chakra-ui/react"
import React from "react"
import { Redirect, useLocation } from "react-router-dom"

import Spinner from "components/elements/Spinner"
import useConfirmEmailToken from "hooks/useConfirmEmailToken"
import {
  completeRegistrationPath,
  confirmEmailPath,
  eventsPath,
  useQuery,
} from "utilities/routes"

const ConfirmEmailFlow = () => {
  const query = useQuery()
  const confirmationToken = query.get("confirmation_token") || ""
  const plan = query.get("plan")
  const invited = query.get("invited") === "1"

  const { pathname } = useLocation()
  const isOnConfirmEmailRoute = pathname === confirmEmailPath()

  const { isFinished, result } = useConfirmEmailToken({
    confirmationToken,
    enabled: isOnConfirmEmailRoute && Boolean(confirmationToken),
  })

  const redirectTo = (isFinished && result?.data?.confirmed)
    ? (result.priorConfirmed === false
      ? (invited ? eventsPath() : completeRegistrationPath(plan ?? null))
      : eventsPath())
    : null

  if (isOnConfirmEmailRoute && Boolean(confirmationToken) && !isFinished) {
    return (
      <Flex h="100vh" w="100%" align="center" justify="center" bg="white">
        <Spinner />
      </Flex>
    )
  }

  if (redirectTo) return <Redirect to={redirectTo} />

  return null
}

export default ConfirmEmailFlow
